import { i as p, x as f, s as b } from "../../lit-element-6iugfgmM.js";
import { e as d } from "../../custom-element-wk-AooBb.js";
import { n as o } from "../../property-BWlAHqg_.js";
import "../../query-assigned-elements-B8U94KLQ.js";
import { Analytics as h } from "../../lib/Analytics.js";
import "../../sp-button-DfcLwvTE.js";
const m = p`.browse-filter-title,.browse-filter-description{margin:4px 0}.browse-filter-image{aspect-ratio:4 / 3;width:100%}.browse-filter-link:focus-visible{outline:-webkit-focus-ring-color auto 3px;outline-offset:5px}`;
var g = Object.defineProperty, y = Object.getOwnPropertyDescriptor, r = (c, i, l, s) => {
  for (var a, t = s > 1 ? void 0 : s ? y(i, l) : i, n = c.length - 1; n >= 0; n--) (a = c[n]) && (t = (s ? a(i, l, t) : a(t)) || t);
  return s && t && g(i, l, t), t;
};
let e = class extends h(b) {
  static get styles() {
    return m;
  }
  connectedCallback() {
    super.connectedCallback(), this.enableClickTracking();
  }
  render() {
    if (this.src) return f`<div><a class="browse-filter-link" href="${this.href}" aria-label="${this.title}"><img class="browse-filter-image" alt="${this.title}" src="${this.src}" loading="lazy"></a><h4 class="browse-filter-title">${this.title}</h4><p class="browse-filter-description"><slot name="description">${this.description}</slot></p></div>`;
  }
};
r([o({ type: String })], e.prototype, "description", 2), r([o({ type: String })], e.prototype, "href", 2), r([o({ type: String })], e.prototype, "src", 2), r([o({ type: String })], e.prototype, "title", 2), e = r([d("af-browse-filter-card")], e);
const S = e;
export {
  S as default
};
//# sourceMappingURL=BrowseFilterCard.js.map
